export default function PhoneCTA({ className = '' }) {
  return (
    <div className={`flex items-start gap-4 ${className}`}>
      <div className="text-[#5f7365] text-2xl shrink-0 pt-0.5">
        <i className="fa-regular fa-phone" aria-hidden="true" />
      </div>
      <div className="space-y-1.5 flex-1 min-w-0">
        <div className="text-xl sm:text-2xl font-bold text-[#5f7365] font-mono tracking-tight">
          <a 
            href="tel:29921879" 
            className="hover:text-[#5f7365] transition-colors inline-block whitespace-nowrap focus:outline-none focus:underline"
            aria-label="Ring til 29 92 18 79"
          >
            <span className="whitespace-nowrap">29 92 18 79</span>
          </a>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-[#4A5D51] pt-1">
          <i className="fa-regular fa-clock text-[#5f7365]" aria-hidden="true" />
          <span className="font-medium">Telefontid: 12.45 - 13.00 på hverdage, undtagen onsdage</span>
        </div>
      </div>
    </div>
  );
}
